import styled from 'styled-components'

export const LogoImg = styled.img`
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  max-width: none;
`
